import type { ReservationAnalyticsEvent, ReservationAnalyticsWriter } from './analyticsTypes.ts';
import { getReservationAnalyticsCollectorUrl } from '../firebase/runtimeEndpoints.ts';
import { recordRuntimeDiagnosticEvent, sanitizeError } from '../../ui/diagnostics/runtimeDiagnostics.ts';

export const createReservationAnalyticsPublicCollectorWriter = (
  collectorUrl = getReservationAnalyticsCollectorUrl()
): ReservationAnalyticsWriter => {
  try {
    recordRuntimeDiagnosticEvent({ event: 'collector:factory:entered', source: 'analyticsPublicCollectorAdapter' });
    const runtimeEnv = (import.meta as any).env;
    recordRuntimeDiagnosticEvent({ event: 'collector:url:resolved', source: 'analyticsPublicCollectorAdapter' });
    console.log('[Analytics] collectorUrl resolved:', collectorUrl);
    console.log('[Analytics] import.meta.env.DEV', runtimeEnv?.DEV);
    recordRuntimeDiagnosticEvent({ event: 'collector:factory:returning', source: 'analyticsPublicCollectorAdapter' });
  } catch (error) {
    const safe = sanitizeError(error);
    recordRuntimeDiagnosticEvent({ event: 'collector:factory:throw', source: 'analyticsPublicCollectorAdapter', errorName: safe.errorName, errorMessage: safe.errorMessage, isAbortLike: safe.isAbortLike });
    throw error;
  }

  return {
    create: async (event: ReservationAnalyticsEvent) => {
      console.log('[Analytics] public collector writer.create invoked', {
        collectorUrl,
        eventId: event.eventId,
        unitId: event.unitId,
        eventType: event.eventType,
      });
      const payload = JSON.stringify({ event });
      console.log('[Analytics] calling fetch', {
        url: collectorUrl,
        method: 'POST',
        payloadLength: payload.length,
      });
      try {
        const response = await fetch(collectorUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true,
        });
        const responseBody = await response.text().catch(error => {
          console.error('[Analytics] failed to read fetch response body', error);
          return '';
        });
        console.log('[Analytics] fetch resolved', {
          status: response.status,
          statusText: response.statusText,
          responseBody,
        });
      } catch (error) {
        console.error('[Analytics] fetch threw', {
          error,
          name: error instanceof Error ? error.name : null,
          message: error instanceof Error ? error.message : null,
          stack: error instanceof Error ? error.stack : null,
          online: navigator.onLine,
          url: collectorUrl,
          userAgent: navigator.userAgent,
        });
        // Public analytics is best-effort and must never surface failures to the UI.
      }
    },
  };
};
